import newColors from "@/styles/newColors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(({
	gridContainer: {
		height: "100%"
	},
	icon: {
		color: newColors.green[400]
	},
	title: {
		fontSize: "32px",
		lineHeight: "24px",
		color: newColors.grey[950]
	},
	subtitle: {
		maxWidth: 400,
		textAlign: "center",
		color: newColors.grey[600]
	},
	closeIcon: {
		color: newColors.red[400]
	}
}))

export default useStyles
